export default __webpack_public_path__ + "static/media/the-keys.efffc90c.png";